import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AdminLogin from "@/pages/AdminLogin";
import ShareholderDashboard from "@/pages/ShareholderDashboard";
import AdminDashboard from "@/pages/AdminDashboard";

function LoginGate({ children, redirect }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) {
    if (redirect) return <Navigate to={redirect} replace />;
    return <Navigate to={user.role === "admin" ? "/admin" : "/accionista"} replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginGate redirect="/accionista"><Login /></LoginGate>} />
          <Route path="/AdminSn2026" element={<LoginGate redirect="/admin"><AdminLogin /></LoginGate>} />
          <Route
            path="/accionista"
            element={
              <ProtectedRoute role="shareholder">
                <ShareholderDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
